/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CheckUserFeaturesRequestItem = typeof CheckUserFeaturesRequestItem[keyof typeof CheckUserFeaturesRequestItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckUserFeaturesRequestItem = {
  DIGITAL_DEPOSIT: 'DIGITAL_DEPOSIT',
  DIGITAL_WITHDRAW: 'DIGITAL_WITHDRAW',
  DIGITAL_CUSTODY: 'DIGITAL_CUSTODY',
  FIAT_DEPOSIT: 'FIAT_DEPOSIT',
  FIAT_WITHDRAW: 'FIAT_WITHDRAW',
  EXCHANGE: 'EXCHANGE',
  BILL_PAYMENT: 'BILL_PAYMENT',
  COMMODITIES: 'COMMODITIES',
  SECURITIES: 'SECURITIES',
  INSURANCE: 'INSURANCE',
  CREDIT_CARD: 'CREDIT_CARD',
  FUND_SUBSCRIPTION: 'FUND_SUBSCRIPTION',
  BOND_SUBSCRIPTION: 'BOND_SUBSCRIPTION',
  IPO: 'IPO',
  REFERRAL: 'REFERRAL',
  SIGNED_AGREEMENT: 'SIGNED_AGREEMENT',
  FGA_KKAM_GLOBAL_MARKET_DATA_SERVICE: 'FGA_KKAM_GLOBAL_MARKET_DATA_SERVICE',
  ALTERNATIVES: 'ALTERNATIVES',
  EXCHANGE_SUB_ACCOUNT: 'EXCHANGE_SUB_ACCOUNT',
  EARN: 'EARN',
  ACCOUNT_MANAGEMENT: 'ACCOUNT_MANAGEMENT',
  CARD_ACCOUNT_MANAGEMENT: 'CARD_ACCOUNT_MANAGEMENT',
  CREDIT_CARD_INJECTION: 'CREDIT_CARD_INJECTION',
  ACCESS_TRANSFER: 'ACCESS_TRANSFER',
  ACCESS_DIGITAL_DEPOSIT: 'ACCESS_DIGITAL_DEPOSIT',
  UNIONPAY_REMITTANCE: 'UNIONPAY_REMITTANCE',
  TRANSFER: 'TRANSFER',
  BANK_TRANSFER: 'BANK_TRANSFER',
  FEE_SCHEDULE: 'FEE_SCHEDULE',
  ACCESS_CARD_BALANCE_WITHDRAW: 'ACCESS_CARD_BALANCE_WITHDRAW',
  WMC_ACCOUNT_UPGEADE: 'WMC_ACCOUNT_UPGEADE',
  TRANSFER_P2P: 'TRANSFER_P2P',
  TRANSFER_SELF: 'TRANSFER_SELF',
  ACCOUNT_UPGRADE: 'ACCOUNT_UPGRADE',
  NEW_APP_EXPERIENCE: 'NEW_APP_EXPERIENCE',
  MANAGE_COLLATERAL_ASSET: 'MANAGE_COLLATERAL_ASSET',
  MANAGE_REPAYMENT_ASSET: 'MANAGE_REPAYMENT_ASSET',
  DOCUMENT_CLASSIFICATION_AI: 'DOCUMENT_CLASSIFICATION_AI',
  AI_KYC_VERIFICATION: 'AI_KYC_VERIFICATION',
  MOBILE_APP_DOWNLOAD_BANNER: 'MOBILE_APP_DOWNLOAD_BANNER',
  OVERVIEW_AUM_BREAKDOWN: 'OVERVIEW_AUM_BREAKDOWN',
  ADDRESS_VERIFICATION_AI: 'ADDRESS_VERIFICATION_AI',
  BANK_INJECTION: 'BANK_INJECTION',
  BANK_PAYOUT: 'BANK_PAYOUT',
} as const;
